// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SGMy","title":"styles_title__yey3f"};